<template>
  <div class="comp_body">
    <img class="comp_x link" v-on:click="$emit('show-assets')" src="/static/img/X.svg">
    <div class="comp_title">
        Notandi
    </div>
    <div class="comp_userinfo">
      <div>
        {{ fullname }}
        <br>
        {{ username }}
      </div>
      <div style="margin-top: 20px">
        <input type="button"  value="ÚTSKRÁ"  v-on:click="on_signout_click">
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import * as storage from '../storage'
import * as srv from '../srv'

export default {
  data () {
    return {
      username: '',
      fullname: ''
    }
  },
  methods: {
    setup () {
      this.username = storage.user.username
      this.fullname = storage.user.fullname
    },
    on_signout_click () {
      srv.signout_browser()
        .then(data => {
          console.log(data.fullname)
          storage.clear()
          this.$emit('show-signin')
        })
        .catch(srv_err => {
          this.$emit('dialog-message', srv_err.error_text, () => {})
        })
    }
  },
  mounted () {
    this.username = storage.user.username
    this.fullname = storage.user.fullname
  }
}
</script>



// WEBPACK FOOTER //
// src/components/User.vue